export default __webpack_public_path__ + "static/media/tweeter-demo.1fdb32c3.gif";